














import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      titlePageChild: "Change password",
      subtitlePageChild: "Change your account's  password",
    };
  },
});
